/** "Dr. Lim Wei Jie" -> "LW" ; "Aisyah Rahman" -> "AR" */
export const initials = (name = '') => {
  const parts = name.replace(/^Dr\.?\s+/i, '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

/** "Dr. Lim Wei Jie" -> "Dr. Lim" */
export const doctorShortName = (name = '') => {
  const m = name.match(/^(Dr\.?)\s+(\S+)/i);
  return m ? `${m[1]} ${m[2]}` : name;
};

/**
 * Malaysian IC display rule: YYMMDD-PB-XXXX with the last 4 digits masked.
 * "900101135566" -> "900101-13-****"
 */
export const maskIC = (ic = '') => {
  const digits = String(ic).replace(/\D/g, '');
  if (digits.length !== 12) return ic ? `${String(ic).slice(0, -4)}****` : '';
  return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-****`;
};

/** Formats the IC as the user types: 900101-13-5566 */
export const formatICInput = (value = '') => {
  const d = value.replace(/\D/g, '').slice(0, 12);
  if (d.length <= 6) return d;
  if (d.length <= 8) return `${d.slice(0, 6)}-${d.slice(6)}`;
  return `${d.slice(0, 6)}-${d.slice(6, 8)}-${d.slice(8)}`;
};

/** Groups a local number for display: 123456789 -> 12 345 6789 */
export const formatLocalPhone = (value = '') => {
  const d = String(value).replace(/\D/g, '');
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)} ${d.slice(2)}`;
  return `${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(5, 9)}${d.length > 9 ? d.slice(9) : ''}`;
};

export const formatPhone = (countryCode, number) =>
  `${countryCode} ${formatLocalPhone(number)}`.trim();

export const stripPhone = (value = '') => String(value).replace(/\D/g, '').replace(/^0+/, '');

export const formatCurrency = (amount, currency = 'RM') => {
  if (amount === null || amount === undefined || amount === '') return `${currency} —`;
  const n = Number(amount);
  return `${currency} ${Number.isInteger(n) ? n : n.toFixed(2)}`;
};

/** "English, Malay, Mandarin" -> "EN, BM, 中文" */
const LANG_SHORT = { English: 'EN', Malay: 'BM', Mandarin: '中文', Cantonese: '粤语' };
export const shortLanguages = (langs = []) => langs.map((l) => LANG_SHORT[l] || l).join(', ');

export const pluralize = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
